import { render } from "./SurveyNew.vue?vue&type=template&id=4d16976e&scoped=true"
import script from "./SurveyNew.vue?vue&type=script&lang=js"
export * from "./SurveyNew.vue?vue&type=script&lang=js"

import "./SurveyNew.vue?vue&type=style&index=0&id=4d16976e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d16976e"]])

export default __exports__